import { Link } from "react-router-dom";
import "./Treat.css";

// =====================================================
// BUY ME A TREAT — the small button beside Like / Comment / Share
//
// Rendered only on posts whose author enabled treats, and never on the
// reader's own post (the callers check both). It opens the separate
// "Choose a Treat" page.
// =====================================================

function BuyTreat({ blogId }) {
  return (
    <Link
      to={`/buy-treat/${blogId}`}
      className="treat-buy-btn"
      onClick={(e) => e.stopPropagation()}
      aria-label="Buy Me a Treat"
    >
      <span aria-hidden="true">🎁</span>
      <span className="treat-buy-label">Buy Me a Treat</span>
    </Link>
  );
}

export default BuyTreat;
